import { HttpInterceptorFn } from '@angular/common/http';

const TRACE_ID_HEADER = 'x-trace-id';
const CORRELATION_ID_HEADER = 'X-Correlation-Id';
const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key';

const shouldDecorateBffRequest = (url: string): boolean => {
  try {
    const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    return parsed.pathname.startsWith('/bff/');
  } catch {
    return url.includes('/bff/');
  }
};

const createId = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
};

export const traceInterceptor: HttpInterceptorFn = (req, next) => {
  if (!shouldDecorateBffRequest(req.url)) {
    return next(req);
  }

  const setHeaders: Record<string, string> = {};

  if (!req.headers.has(TRACE_ID_HEADER)) {
    setHeaders[TRACE_ID_HEADER] = createId();
  }

  if (!req.headers.has(CORRELATION_ID_HEADER)) {
    setHeaders[CORRELATION_ID_HEADER] = setHeaders[TRACE_ID_HEADER] ?? createId();
  }

  if (req.method === 'POST' && !req.headers.has(IDEMPOTENCY_KEY_HEADER)) {
    setHeaders[IDEMPOTENCY_KEY_HEADER] = createId();
  }

  if (Object.keys(setHeaders).length === 0) {
    return next(req);
  }

  return next(req.clone({ setHeaders }));
};
